import type { TraceTimelineItem } from './types';

/** Cumulative updates are idempotent across stream replay and preserve tool ordering. */
export function upsertProgressTimeline(
  timeline: TraceTimelineItem[],
  text: string,
  progressId?: string
): void {
  const index = progressId
    ? timeline.findIndex(item => item.type === 'progress' && item.id === progressId)
    : -1;
  if (index >= 0) timeline[index] = { type: 'progress', id: progressId!, content: text };
  else
    timeline.push({
      type: 'progress',
      id: progressId || `progress-${timeline.length + 1}`,
      content: text,
    });
}
